import styled from "styled-components";
export const MainPageStyle = styled.div`

.scroll-to-top img{
    width: 60px;
}
`;